import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const ThirdPage = () => (
  <Layout>
    <SEO title="Page three" />
    <section className="text-gray-700 body-font">
      <div className="container px-5 py-24 mx-auto">
        <div className="flex flex-col text-center w-full mb-20">
          <h1 className="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">
            O nás
          </h1>
          <p className="lg:w-2/3 mx-auto leading-relaxed text-base text-justify mb-4">
            ZEAINVENT a.s. prešla v nedávnej minulosti zásadnými zmenami,
            zanikla semenárska výroba a obchod s osivami, došlo k zníženiu
            hodnoty majetku, znížil sa počet zamestnancov. Do hospodárskeho roku
            2007/2008 vstupovala spoločnosť s cieľom zabezpečiť nový rozbeh
            šľachtiteľskej činnosti ako hlavnej činnosti spoločnosti. Prvým
            konkrétnym výsledkom nového začiatku nášho šľachtenia kukurice bolo
            povolenie (registrácia) dvoch nových hybridov PYROXÉNIA a STRONCIA
            na jar 2008.
          </p>

          <p className="lg:w-2/3 mx-auto leading-relaxed text-base text-justify mb-4">
            V štátnych odrodových pokusoch bolo zároveň zaradených 1. a 2. rokom
            celkovo 12 našich hybridov kukurice na zrno a siláž. Intenzívna
            šľachtiteľská práca prebiehala v zimnej šľachtiteľskej škôlke v
            Mexiku a pokračuje od jari 2008 na našej šľachtiteľskej báze Farský
            Mlyn a v Topoľníkoch. Ďalším zdrojom financovania šľachtenia sa
            stala výroba a predaj osív rodičovských komponentov do
            registrovaných hybridov kukurice vo vlastníctve iných spoločností.
            Od jarnej sezóny 2008 sme zároveň započali s vlastnou výrobou
            finálneho osiva kukurice a to konkrétne hybridu PYROXÉNIA a hybridu
            STRONCIA. Ako doplnkové činnosti k šľachteniu sme na jar 2008 začali
            aj s riešením výskumného projektu pre Slovenské centrum
            poľnohospodárskeho výskumu, s testovaním herbicídov a testovaním
            hybridov pre iné spoločnosti. Pristúpili sme k majetkovému a
            právnemu osamostatneniu a odčleneniu šľachtenia od akciovej
            spoločnosti a to formou založenia novej spoločnosti s ručením
            obmedzeným ZEAINVENT TRNAVA s.r.o. so sídlom ŠM Farský Mlyn 2/6913,
            917 01 Trnava.
          </p>

          <p className="lg:w-2/3 mx-auto leading-relaxed text-base text-justify mb-4">
            Spoločnosť vznikla zápisom do Obchodného registra Okresného súdu
            Trnava dňa 20.5.2008. Samotnú hospodársku činnosť zahájila dňom
            1.7.2008, keď do spoločnosti prešlo 17 bývalých zamestnancov
            materskej spoločnosti. Do majetku s.r.o. prešli z a.s. kúpnou
            zmluvou aktíva súvisiace s výskumno-šťachtiteľskou a semenárskou
            činnosťou. V súlade so svojim predmetom podnikania pokračuje
            novozaložená spoločnosť v činnosti novošľachtenia a udržovacieho
            šľachtenia kukurice, v nadväznosti na činnosť svojej materskej
            spoločnosti a jej právnych predchodcov. Nadväzuje tak na viac ako 50
            ročné tradície šľachtenia kukurice na Slovensku.
          </p>
        </div>
        <div className="flex flex-wrap -m-2">
          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg">
              <img
                alt="team"
                className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                src="https://dummyimage.com/80x80"
              />
              <div className="flex-grow">
                <h2 className="text-gray-900 title-font font-medium">
                  Milan Serbák
                </h2>
                <p className="text-gray-500">konateľ Zeainvent Trnava s.r.o.</p>
                <p className="text-gray-500">milan.serbak@zeainvent.com</p>
              </div>
            </div>
          </div>
          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg">
              <img
                alt="team"
                className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                src="https://dummyimage.com/84x84"
              />
              <div className="flex-grow">
                <h2 className="text-gray-900 title-font font-medium">
                  Jaromír Serbák
                </h2>
                <p className="text-gray-500">...</p>
                <p className="text-gray-500">jaromir.serbak@zeainvent.com</p>
              </div>
            </div>
          </div>
          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg">
              <img
                alt="team"
                className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                src="https://dummyimage.com/88x88"
              />
              <div className="flex-grow">
                <h2 className="text-gray-900 title-font font-medium">
                  Ivana Miháliková
                </h2>
                <p className="text-gray-500">...</p>
                <p className="text-gray-500">ivana.mihalikova@zeainvent.com</p>
              </div>
            </div>
          </div>
          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg">
              <img
                alt="team"
                className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                src="https://dummyimage.com/90x90"
              />
              <div className="flex-grow">
                <h2 className="text-gray-900 title-font font-medium">
                  Masnica
                </h2>
                <p className="text-gray-500">...</p>
                <p className="text-gray-500">masnica@zeainvent.com</p>
              </div>
            </div>
          </div>
          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg">
              <img
                alt="team"
                className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                src="https://dummyimage.com/94x94"
              />
              <div className="flex-grow">
                <h2 className="text-gray-900 title-font font-medium">
                  Danihelová
                </h2>
                <p className="text-gray-500">...</p>
                <p className="text-gray-500">danihelova@zeainvent.com</p>
              </div>
            </div>
          </div>
          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg">
              <img
                alt="team"
                className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                src="https://dummyimage.com/98x98"
              />
              <div className="flex-grow">
                <h2 className="text-gray-900 title-font font-medium">
                  Nádaský
                </h2>
                <p className="text-gray-500">...</p>
                <p className="text-gray-500">nadasky@zeainvent.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Layout>
)

export default ThirdPage
